__turbopack_context__.v({
  "logoImage": "Motto-module__SxwtMa__logoImage",
  "mainMotto": "Motto-module__SxwtMa__mainMotto",
  "model3D": "Motto-module__SxwtMa__model3D",
  "mottoText": "Motto-module__SxwtMa__mottoText",
  "textContainer": "Motto-module__SxwtMa__textContainer",
});
